import {useEffect} from "react";

export const useInjectFavicon = (faviconUrl) => {

  useEffect(() => {
    if (!faviconUrl) {
      return;
    }

    const PUBLIC_URL = process.env.PUBLIC_URL || "";

    const existing = document.querySelector("link[rel='icon']");
    if (existing) {
      existing.parentNode.removeChild(existing);
    }

    const link = document.createElement("link");
    link.rel = "icon";
    link.href = `${PUBLIC_URL}${faviconUrl}`;
    document.head.appendChild(link);
    return () => {
      link?.parentNode?.removeChild(link);
    };

  }, [faviconUrl]);
};

export default useInjectFavicon;